import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { SchemaI18n } from '@bingads-webui-universal/schema-i18n';
import { GridCustomizedPopupEditor } from '@bingads-webui-campaign/grid-customized-popup-editor';
import { inlineEditSave } from '@bingads-webui-campaign/summary-grid-helper';
import CampaignCacheManager from '@bingads-webui-campaign-legacy/cache-manager';
import template from './rsa-ad-customizer-attribute-template.pug';
import { AdCustomizerAttributeInlineEditor } from './inline-editor-view';

export class RSAAdCustomizerAttributeColumn extends CampaignuiBaseColumn {
  constructor(columnConfig) {
    const {
      Name,
      i18n,
      i18nErrors,
      Datatype,
      gridType,
      resource,
      gridView,
      permissions,
    } = columnConfig;
    const dataTypeI18nKey = `RSAAdCustomizer_Attribute_${Datatype}`;
    super(_.defaults({
      title: `${Name} (${i18n.getString(dataTypeI18nKey)})`,
      name: `RSAAdCustomizerAttributes-${Name}`,
      property: 'RSAAdCustomizerAttributes',
      sortable: false,
      bodyClasses: ['grid-column-Delivery'],
      i18n,
      enableEdit: item => gridType !== 'Campaign' || item.CampaignType === 'Default',
    }, columnConfig));

    this.rawName = Name;
    this.gridType = gridType;
    this.resource = resource;
    this.i18n = i18n;
    this.i18nErrors = i18nErrors;
    this.gridView = gridView;
    this.dataType = Datatype;
    this.permissions = permissions;
  }

  get title() {
    return this.config.title;
  }

  onPrompt({ event, item, newPosition }) {
    if (event.target.className.includes('editorial-status')) {
      return null;
    }
    const RSAAdCustomizerAttribute = this.findAttribute(item.RSAAdCustomizerAttributes);
    if (!RSAAdCustomizerAttribute) return null;

    const AdCustomizerAttributeInlineEditorView = new AdCustomizerAttributeInlineEditor({
      i18n: this.i18n,
      isUsingInheritedValue: this.gridType !== RSAAdCustomizerAttribute.ValueSetAtLevel,
      inheritedValue: RSAAdCustomizerAttribute.InheritedValue,
      inheritedValueLevel: RSAAdCustomizerAttribute.InheritedValueSetAtLevel,
      valueLevel: RSAAdCustomizerAttribute.ValueSetAtLevel,
      value: RSAAdCustomizerAttribute.Value,
      currentLevel: this.gridType,
      dataType: this.dataType,
      attributeName: RSAAdCustomizerAttribute.Name,
    });

    AdCustomizerAttributeInlineEditorView.on('save', ({ value }) => {
      inlineEditSave({
        id: RSAAdCustomizerAttribute.Id,
        additionalPayload: {
          Name: RSAAdCustomizerAttribute.Name,
          AdCustomizerAttributeValue: value,
          [this.gridType]: { Id: item.Id },
        },
      }, {
        gridView: this.gridView,
        resource: this.resource,
        i18n: this.i18n,
        i18nErrors: this.i18nErrors,
        editorView: AdCustomizerAttributeInlineEditorView,
        editorViewCallbackAfterUpdate: () => {
          AdCustomizerAttributeInlineEditorView.trigger('close');
          CampaignCacheManager.invalidate('AdCustomizerAttribute');
          this.gridView.refresh(true);
        },
      });
    });
    const groupClass = `grid-group-${_.result(this.config, 'group', 'other')}`;
    const editorView = new GridCustomizedPopupEditor({
      editorView: AdCustomizerAttributeInlineEditorView.render(),
      cellPosition: newPosition,
      renderBelow: false,
      className: `grid-popupeditor ${groupClass}`,
      parentContainerSelector: '.grid-and-disclaim-container',
    });

    return editorView.render();
  }

  pickProperty(item) {
    return {
      RSAAdCustomizerAttribute: this.findAttribute(item.RSAAdCustomizerAttributes),
    };
  }

  findAttribute(attributes) {
    return _.find(attributes, attribute => attribute.Name === this.rawName);
  }

  template({ value }) {
    const { RSAAdCustomizerAttribute } = value;
    const schemaI18n = new SchemaI18n({ i18n: this.config.i18n });

    let defaultValue = '-';
    let showInheritIcon = false;
    if (RSAAdCustomizerAttribute && !_.isEmpty(RSAAdCustomizerAttribute.Value)) {
      defaultValue = RSAAdCustomizerAttribute.Value;
      if (this.gridType !== RSAAdCustomizerAttribute.ValueSetAtLevel) {
        showInheritIcon = true;
      }
    }
    const editorialStatus =
      RSAAdCustomizerAttribute ? RSAAdCustomizerAttribute.EditorialStatus : null;
    return template({
      Value: defaultValue,
      editorialStatus,
      editorialStatusText: editorialStatus ? schemaI18n.enum('EditorialStatus', editorialStatus) : null,
      showInheritIcon,
      i18n: this.i18n,
      permissions: this.permissions,
      Id: RSAAdCustomizerAttribute ? RSAAdCustomizerAttribute.Id : '',
      ValueSetAtLevel: RSAAdCustomizerAttribute ? RSAAdCustomizerAttribute.ValueSetAtLevel : '',
    });
  }
}
